<template>
  <div class="user-page">
    <page-title>
      {{isMyProfile ? $t('labels.my_profile') : $t('employees.info') }}
    </page-title>
    <el-tabs v-model="activeTab" v-if="user">
      <el-tab-pane :label="$t('students.profile')" name="user">
        <user-page :user="user"></user-page>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
  import UserPage from '@/components/Users/Page/UserSummary.vue'
  export default {
    components: {
      UserPage
    },
    props: ['id'],
    data () {
      return {
        activeTab: 'user'
      }
    },
    computed: {
      user () {
        return this.$store.state.users.users[this.id]
      },
      isMyProfile () {
        if (this.user && this.$store.state.user.user) {
          return this.user.getId() === this.$store.state.user.user.getId()
        } else {
          return false
        }
      },
      isAdmin () {
        if (this.user) {
          return this.user.checkRole('ADMINN')
        }
      }
    },
    methods: {
      async loadUser () {
        try {
          await this.$store.dispatch('users/loadUser', this.id)
        } catch (error) {
          console.log('LOG: loadUser -> error', error.error)
          if (error.error.data.error.code === 'E_PARAM') {
            this.$router.push({name: 'notFound'})
          } else {
            // @ts-ignore
            this.$message.error(this.$t('labels.can_not_load_user'))
          }
        }
      }
    },
    mounted () {
      this.loadUser()
      this.$bus.$on('pathChanged', this.loadUser)
    },
    beforeDestroy () {
      console.log('DESTROY')
      this.$bus.$off('pathChanged', this.loadUser)
    }
  }
</script>
<style lang="scss">
  @import 'src/assets/sass/paper/variables';

  .user-page {
    .el-tabs {
      &__nav-wrap {
        padding: 0 30px;
        background: #fff;
        border-radius: $global-radius;
        box-shadow: 0px 5px 25px rgba(0, 0, 0, 0.05);

        &:after {
          display: none;
        }
      }

      &__content {
        overflow: visible;
      }

      &__item {
        font-weight: 400;
        color: $secondary-font-color;

        &.is-active {
          color: #1989fa;

          a {
            color: #1989fa;
          }
        }

        &:focus.is-active.is-focus:not(:active) {
          box-shadow: none;
        }
      }

      &__active-bar {
        height: 3px;
        background-color: #1989fa;
      }
    }
  }

  .user-page-not-found {
    a {
      color: $link-color;
    }
  }
</style>

